
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/armored-rentals",
      function () {
        return require("private-next-pages/armored-rentals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/armored-rentals"])
      });
    }
  